// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EditTwoToneSvg from "@ant-design/icons-svg/es/asn/EditTwoTone";
import AntdIcon from '../components/AntdIcon';

var EditTwoTone = function EditTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EditTwoToneSvg
  }));
};

EditTwoTone.displayName = 'EditTwoTone';
export default React.forwardRef(EditTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/EditTwoTone.js
// module id = 1007
// module chunks = 0